﻿import {getCookie} from "../utils/cookie";

export function trackEvent(category: string, action: string, label: string, value: number) {
	const dataLayer = (<any>window).dataLayer || [];
	dataLayer.push({
		event: action,
		event_category: category,
		event_label: label,
		value: value
	});

	if (typeof gtag === 'function') {
		gtag('event', action, {
			'event_category': category,
			'event_label': label,
			'value': value
		});
	}
	else if (typeof ga === 'function') {
		ga('technical.send', 'event', category, action, label, value);
	}
}

interface IOrderStatusLabel {
	orderNumber?: string;
	orderStatus?: string;
	paymentStatus?: string;
	pvc?: string;
	repro?: boolean;
}

export function trackOrderStatusEvent(action: string, partialLabel: IOrderStatusLabel, nrOrdersInAccount = -1, nrItemsInOrder = -1) {
	const label = { accountId: getCookie('accid'), ...partialLabel };
	trackEvent('OrderStatus', action, JSON.stringify(label), nrOrdersInAccount > 0 ? nrOrdersInAccount : nrItemsInOrder);
}

export function trackContactPageEvent(action: string) {
	trackEvent('ContactPage', action, '', -1);
}

export function trackSortingOnPop(action: string) {
	trackEvent('SortingOnPOP', action, '', -1);
}

export function trackComponentEvent(action: string) {
	trackEvent('Component', action, '', -1);
}

export function trackAddressValidationEvent(action: string) {
	trackEvent('AddressValidation', action, '', -1);
}
